<style scoped lang="css">
  .link-configuracao {
    cursor: pointer;
  }
  .filtro-metas{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap:16px;
  }
  .status-filter{
    padding: 16px 0;
  }
</style>
<template>
    <div class="app-form frame-page basic-form-vue">
      <div class="h-panel">
        <div class="h-panel-bar">
          <span class="h-panel-title">Metas: estágio configuração</span>
        </div>
        <div class="h-panel-body">
          <div class="h-row filtro-metas">
            <label>Selecione um ano
              <Select v-width="300" :null-option="false" filterable v-model="ano" :datas="selectAnos"></Select>
            </label>
            <label v-width="300">Meses do ano
              <sumoSelect :value="meses" ref="messes" @input="updateMeses" :options="selectMesAno" multiple placeholder="Empresas" />
            </label>
            <label  v-width="300">Empresas
              <sumoSelect :value="empresas" ref="empresas" @input="updateEmpresas" :options="selectEmpresas" multiple placeholder="Empresas" />
            </label>
          </div>
          <div class="h-row status-filter">
           <div><h-switch v-model="status" :small="true">
           Mostrar empresas com estágio de configuração pendente
           </h-switch></div>
          </div>
          <div class="h-row text-center">
            <span title="não iniciou" class="h-tag h-tag-red">
              Não: Sem configuração
            </span>

            <span title="não iniciou" class="h-tag h-tag-yellow">
              Ini. Configuração iniciada
            </span>

            <span title="não iniciou" class="h-tag h-tag-green">
              Sim: Configuração concluída
            </span>
          </div>

          <div class="h-row">&nbsp;</div>

          <div class="h-row">
            <Table  border stripe :datas="currentData">
              <TableItem v-for="(column, index) in currentColumns" :key="`estagio-${index}`" :width="column.width" :title="column.title">
                <template slot-scope="{data}">

                  <span   data-test-estagio title="não iniciou" @click="configurar(data.empresaId, column.prop.replace('mes', ''))" v-if="data[column.prop] == '0'" class="h-tag h-tag-red link-configuracao">
                    Não
                  </span>

                  <span  data-test-estagio title="iniciou configuração" @click="configurar(data.empresaId, column.prop.replace('mes', ''))" v-else-if="data[column.prop] == '1'" class="h-tag h-tag-yellow link-configuracao">
                    ini.
                  </span>

                  <span  data-test-estagio title="concluiu" @click="configurar(data.empresaId, column.prop.replace('mes', ''))" v-else-if="data[column.prop] == '2'" class="h-tag h-tag-green link-configuracao">
                    Sim
                  </span>

                  <span v-else>{{data[column.prop]}}</span>
                </template>
              </TableItem>
              <div slot="empty">Não existem dados</div>
            </Table>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');
export default {
  data() {
    return {
      ano: 0,
      empresas: [],
      status: false,
      selectAnos: [],
      selectEmpresas: [],
      meses: [],
      selectMesAno: [
        { title: 'Janeiro', key: 'mes1' },
        { title: 'Fevereiro', key: 'mes2' },
        { title: 'Março', key: 'mes3' },
        { title: 'Abril', key: 'mes4' },
        { title: 'Maio', key: 'mes5' },
        { title: 'Junho', key: 'mes6' },
        { title: 'Julho', key: 'mes7' },
        { title: 'Agosto', key: 'mes8' },
        { title: 'Setembro', key: 'mes9' },
        { title: 'Outubro', key: 'mes10' },
        { title: 'Novembro', key: 'mes11' },
        { title: 'Dezembro', key: 'mes12' }
      ],
      datas: [],
      datasFilter: [],
      columns: [],
      filterColumns: []
    };
  },
  watch: {
    ano: async function () {
      const resp = await R.Metas.estagioConfiguracao(this.ano);
      if (resp.ok) {
        const dados = resp.data;
        this.selectEmpresas = dados.map(x => ({ title: x.empresaNome, key: x.empresaId }));
        this.datas = dados.map(x => {
          const dado = { 'empresaNome': x.empresaNome, 'empresaId': x.empresaId };
          for (const mes in x.estagioMes) {
            dado[`mes${mes}`] = x.estagioMes[mes];
          }
          return dado;
        });
      }
    },
    empresas() {
      this.filtrar();
    },
    status() {
      this.filtrar();
    },
    meses(value) {
      const arrayColunas = ['empresaNome', ...value];
      const clone = JSON.parse(JSON.stringify(this.columns));

      const filter = clone.filter(m => {
        return arrayColunas.includes(m.prop);
      });

      this.filterColumns = filter;
    }
  },
  computed: {
    aplicarFiltros() {
      return this.empresas.length || this.status;
    },
    aplicarFiltroColunas() {
      return this.filterColumns.length > 1;
    },
    currentData() {
      return this.aplicarFiltros ? this.datasFilter : this.datas;
    },
    haEmpresasSelecionadas() {
      return this.empresas.length;
    },
    filtro() {
      const clone = JSON.parse(JSON.stringify(this.datas));
      let filter = clone;

      if (this.haEmpresasSelecionadas) {
        filter = clone.filter(f => {
          return this.empresas.includes(f.empresaId);
        });
      }

      if (this.status) {
        filter = filter.filter(empresas => {
          const keys = Object.keys(empresas)
            .filter(k => /mes/.test(k));

          const isEstagioCompleto = keys.reduce((acc, k, i) => {
            acc.push(empresas[k]);
            if (i + 1 === keys.length) acc = acc.every(s => s === '2');
            return acc;
          }, []);

          return !isEstagioCompleto;
        });
      }

      return filter;
    },
    currentColumns() {
      return this.aplicarFiltroColunas
        ? this.filterColumns
        : this.columns;
    }
  },
  created() {
    Utils.trackingF360(this, 'Listar', 'Metas - Estágio de Configuração');
  },
  mounted: async function () {
    const ano = new Date().getFullYear();
    for (let i = (ano - 15); i <= ano + 3; i++) {
      this.selectAnos.push({ title: String(i), key: i });
    }

    this.ano = ano;

    this.columns.push({
      title: 'Empresa',
      prop: 'empresaNome',
      width: 120
    });

    moment.monthsShort().forEach((x, i) => {
      this.columns.push({
        title: x,
        prop: `mes${i + 1}`,
        width: 70
      });
    });
  },
  methods: {
    configurar: function (empresaId, mes) {
      // this.$router.push(`/metas/configurar?empresa=${empresaId}&data=${mes.padStart(2, 0)}/${this.ano}`);
      this.$router.push({
        name: 'metas-configurar',
        query: { empresa: empresaId, data: mes.padStart(2, 0), ano: this.ano }
      });
    },
    filtrar() {
      this.datasFilter = this.filtro;
    },
    updateEmpresas(value) {
      this.empresas = value;
    },
    updateMeses(value) {
      this.meses = value;
    }
  }
};
</script>
